import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchItems } from "../../features/items/itemsSlice";
// import Search from "../Search";
import Item from "./Item";

export default function AllItems() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchItems());
  }, [dispatch]);
  const { isLoding, isError, items, error } = useSelector(
    (state) => state.item
  );
  const { search, type } = useSelector((state) => state.filter);
  // console.log(search);

  let content;

  // const transactions = items.revers();
  // console.log(transactions);

  if (isLoding && !isError) {
    content = <p>......loding......</p>;
  }
  if (!isLoding && isError) {
    content = <p>{error}</p>;
  }
  if (!isLoding && !isError && items.length > 0) {
    content = items
      ?.filter((item) => {
        if (search.length > 0) {
          console.log(item.name.toLowerCase());
          return item.name.toLowerCase().includes(search);
        } else {
          return true;
        }
      })
      .filter((item) => {
        if (type.length > 0) {
          return item.type === type;
        } else {
          return true;
        }
      })
      .map((item) => <Item key={item.key} item={item} />);
  }
  if (!isLoding && !isError && items.length === 0) {
    content = <p className="nothing ">There is no content!!</p>;
  }

  return (
    <div>
      {/* <Search /> */}
      {content}
    </div>
  );
}
